import { render, staticRenderFns } from "./main.vue?vue&type=template&id=ddb53056&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=ddb53056&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb53056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddb53056')) {
      api.createRecord('ddb53056', component.options)
    } else {
      api.reload('ddb53056', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=ddb53056&scoped=true", function () {
      api.rerender('ddb53056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/datePickerGroup/main.vue"
export default component.exports